import base32 from 'hi-base32'

export default async function encodeBase32(input) {
  return base32.encode(input)
}
